import React from 'react';
import HeaderType from './PropTypes/PVPartnerContentHeader';
import HeaderForm from './PVTemplate1Form';
import '../../../../Content/PVTemplate1.css';
import { createHTMLText } from '../../../helpers/textFunctions';

const PVTemplate1HeaderWithForm = (props) => {
    const { data } = props;

    const getImgBgClass = () => (data.header.imgBgClass ? data.header.imgBgClass : '');

    const displayImage = (imgPathLogo, src, altText) => {
        if (src !== undefined && src !== null) {
            return src.length > 0 ? <img src={"https://cloud.squidex.io/api/assets/" + src[0]} alt={altText} /> : '';
        } else if (imgPathLogo !== undefined && imgPathLogo !== null) {
            return imgPathLogo.length > 0 ? <img src={imgPathLogo} alt={altText} /> : '';
        } else {
            return '';
        }
    }
        
    /* eslint-disable react/no-danger */
    const headerBottomText =
        data.headerBottomRow.fullWidth === false ? (
            <React.Fragment>
                <div
                    className="col pv-template1-header-bottom-text"
                    dangerouslySetInnerHTML={createHTMLText(data.headerBottomRow.body)}
                />
                <div
                    className="col pv-template1-header-bottom-text"
                    dangerouslySetInnerHTML={createHTMLText(data.headerBottomRow.body2)}
                />
            </React.Fragment>
        ) : (
                <React.Fragment>
            <div
                className="col pv-template1-header-bottom-text opt2"
                dangerouslySetInnerHTML={createHTMLText(data.headerBottomRow.body)}
                />
                 <div
                className="col pv-template1-header-bottom-text opt2"
                dangerouslySetInnerHTML={createHTMLText(data.headerBottomRow.body2)}
            />
                </React.Fragment >
        );

    return (
        <React.Fragment>
            <div className="pv-template1-header-wrapper">
                <div className={`pv-template1-header ${data.header.class}`}>
                    <div className="container pv-template1-header-container">
                        <div className="row pv-template1-header-row">
                            <div className="col-sm-12 pv-template1-header-body">
                                <div
                                    className={`pv-template1-header-title ${data.header.textColorClass}`}
                                >
                                    <h1
                                        dangerouslySetInnerHTML={createHTMLText(data.header.title)}
                                    />
                                </div>
                                <div
                                    className={`pv-template1-header-text-wrapper ${data.header.textColorClass}`}
                                    dangerouslySetInnerHTML={createHTMLText(data.header.body)}
                                />
                                <div className="pv-template1-header-logo">
                                    {displayImage(data.header.imgPathLogo, data.header.src, 'Header Logo')}
                                </div>
                                <div className={`pv-template1-header-spacer ${getImgBgClass()}`} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row pv-template1-header-bottom-row-wrapper">
                        {headerBottomText}
                    </div>
                </div>
                <HeaderForm formData={data.formData} />
            </div>
        </React.Fragment>
    );
    /* eslint-enable react/no-danger */
};

PVTemplate1HeaderWithForm.propTypes = {
    data: HeaderType,
};

PVTemplate1HeaderWithForm.defaultProps = {
    data: {},
};

export default PVTemplate1HeaderWithForm;
